module.exports = __webpack_public_path__ + "static/media/strategies-white.536e5595.svg";